import React from 'react';
import { WebLayout } from 'components/Layout';
import { motion } from 'framer-motion';
import { Heart, ShoppingCart } from 'react-feather';

export const Wishlist = () => {
  const fadeUp = {
    hidden: { opacity: 0, y: 20 },
    visible: { opacity: 1, y: 0, transition: { duration: 0.6 } },
  };

  const wishlist = [
    {
      id: 1,
      name: 'Classic Wardrobe',
      price: 450,
      image: 'assets/landing/newest/three.png',
    },
    {
      id: 2,
      name: 'Wooden Bed Frame',
      price: 650,
      image: 'assets/landing/newest/four.png',
    },
  ];

  return (
    <WebLayout>
      <section className="bg-[#FFF6F2] py-16 px-6 sm:px-12 lg:px-24">
        <motion.h1
          className="text-3xl sm:text-4xl font-semibold text-[#AC3F1E] mb-12 text-center"
          variants={fadeUp}
          initial="hidden"
          animate="visible"
        >
          Wishlist
        </motion.h1>

        {wishlist.length === 0 ? (
          <p className="text-center text-gray-600">Your wishlist is empty.</p>
        ) : (
          <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-8 max-w-6xl mx-auto">
            {wishlist.map((item) => (
              <motion.div
                key={item.id}
                className="bg-white shadow-md rounded-lg overflow-hidden flex flex-col"
                variants={fadeUp}
                initial="hidden"
                animate="visible"
              >
                <img src={item.image} alt={item.name} className="w-full h-56 object-cover" />
                <div className="p-6 flex flex-col justify-between flex-grow">
                  <div>
                    <h3 className="text-lg font-semibold text-gray-800">{item.name}</h3>
                    <p className="text-sm text-gray-600 mt-2">${item.price}</p>
                  </div>
                  <div className="flex items-center justify-between mt-6">
                    <button className="text-[#AC3F1E] hover:text-red-500 transition">
                      <Heart size={20} fill="#AC3F1E" />
                    </button>
                    <button className="bg-[#AC3F1E] text-white text-sm uppercase tracking-wide px-4 py-2 font-semibold hover:opacity-90 transition flex items-center gap-2">
                      <ShoppingCart size={16} /> Add to Cart
                    </button>
                  </div>
                </div>
              </motion.div>
            ))}
          </div>
        )}
      </section>
    </WebLayout>
  );
};
